<div class="demographic-item">
  <div class="demographic-item-chart">
    <canvas #canvasRef></canvas>
  </div>
  <div class="demographic-item-legend" *ngIf="!shouldHideLegend" #chartLegendsRef></div>
</div>
